import {actions as A} from '../constants/actions';

const defaultState = {
  prevCompletedStepSign: false,
};

export default (state = defaultState, {type}) => {
  switch(type) {
    case A.PREVIOUSLY_COMPLETED_STEP_SIGN_TRUE:
      return {...state, prevCompletedStepSign: true};

    case A.PREVIOUSLY_COMPLETED_STEP_SIGN_FALSE:
      return {...state, prevCompletedStepSign: false};

    default:
      return state;
  }
}
